/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';

import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { IncomReportData } from 'src/@types/Choqorak/MainTables/Income/Income';
import { DateConverter } from 'src/sections/common/DateConverter';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';

type Props = {
  startDate?: Date;
  endDate?: Date;
  Report?: IncomReportData;

};

export default function IncomeReportPDF({ startDate, endDate, Report }: Props) {
  const recordsPerPage = 37;
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');

  const lang = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirction]);

  if (!Report || !Report.list || Report.list.length === 0) {
    return <Loader />;
  }

  const thStyle = `table-th-Attandence-Report text-[12px]`;

  const tdStyle = `table-td-Attandence-Report text-[11px]`;

  const width = 'w-[240mm]';

  const totalPages = Math.ceil(Report!.list.length / recordsPerPage);
  const groupedReport = Report.report.reduce((acc, item) => {
    const { carrencyName, incomeCategoryName, totalAmount } = item;

    if (!acc[carrencyName]) {
      acc[carrencyName] = {};
    }

    if (!acc[carrencyName][incomeCategoryName]) {
      acc[carrencyName][incomeCategoryName] = 0;
    }

    acc[carrencyName][incomeCategoryName] += totalAmount;

    return acc;
  }, {} as Record<string, Record<string, number>>);

  const grandTotalsByCurrency = Object.entries(groupedReport).reduce((acc, [currency, categories]) => {
    const total = Object.values(categories).reduce((sum, val) => sum + val, 0);
    acc[currency] = total;
    return acc;
  }, {} as Record<string, number>);

  return (
    <>
      <div className="px-7">
        {Report.list.length > 0 ? (
          <>
            {/* Loop through pages */}
            {Array.from({ length: totalPages }).map((_, pageIndex) => (
              <div
                key={pageIndex}
                className={`${width} h-[297mm] mx-auto bg-white text-black`}
                dir={`${dirction}`}
              >
                <div className="page-break py-5 px-2">
                  <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                    <div className="flex justify-between items-center px-5">
                      {/* Left Logo */}
                      <div className="flex flex-col justify-center items-center text-center">
                        <img
                          src={require('src/assets/Choqorak/logo1.png')}
                          width="100"
                          height="100"
                          alt="logo1"
                        />
                      </div>

                      {/* Center Text */}
                      <div className="text-base text-center font-bold print:text-base">
                        <h3>چقرک مرکز پخش مواد خوراکی</h3>
                        <h3>گزارش عمومی عواید</h3>
                        {startDate && endDate && startDate.getTime() !== endDate.getTime() ? (
                          <h3>
                            {startDate && endDate
                              ? `گزارش عواید از ${startDate.toLocaleDateString('fa-AF')} الی ${endDate.toLocaleDateString('fa-AF')}`
                              : 'تاریخ مشخص نشده است'}
                          </h3>
                        ) : (
                          <h3>
                            {startDate && endDate
                              ? `گزارش عواید از ${startDate.toLocaleDateString('fa-AF')} `
                              : 'تاریخ مشخص نشده است'}
                          </h3>
                        )}
                      </div>

                      {/* Right Logo */}
                      <div className="flex flex-col justify-center items-center text-center">
                        <img
                          src={require('src/assets/Choqorak/logo2.png')}
                          width="200"
                          height="400"
                          alt="logo2"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <table className="table-style print:text-black">
                      <thead className=" bg-gray-600">
                        <tr className="w-full bg-gray-600 print:bg-gray-600">
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('GeneralFields.No')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('IncomeCategory.IncomeCategory')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('Income.Amount')}
                          </th>

                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('Income.Date')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('Income.Description')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Report!.list
                          .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                          .map((record: any, index: number) => (
                            <tr key={index} style={{ pageBreakInside: 'avoid' }}>
                              <td className={`${tdStyle}`}>{pageIndex * recordsPerPage + index + 1}</td>

                              <td className={`${tdStyle}`}>{record.incomeCategory}</td>
                              <td className={`${tdStyle}`}>{record.amount}{' '}
                                {record.carrencyId === 2
                                  ? GetCurrencySymbol('afn')
                                  : GetCurrencySymbol('dollar')}</td>


                              <td className={`${tdStyle}`}>
                                {' '}
                                {<DateConverter date={record.recieveDate} />}
                              </td>
                                <td className={`${tdStyle}`}>
                                {' '}
                                {record.description}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Footer for each page */}
                  {/* <div
              className={`absolute bottom-5 w-[230mm] mx-auto border-t-2 border-black text-[8pt]`}
            >
              <div className="px-5 relative w-full mx-auto" dir="ltr">
                <div className="flex justify-center items-center w-full">
                  <img
                    src={require('src/assets/Choqorak/footer.png')}
                    width="500"
                    height="50"
                    alt="footer"
                  />
                </div>
              </div>
            </div> */}
                </div>

                {/* Show Summary ONLY on the Last Page */}
                {pageIndex === totalPages - 1 && (
                  <div
                    className={`${width} h-[297mm] mx-auto bg-white text-black`}
                    dir={`${dirction}`}
                  >
                    <div className="page-break py-5 px-2">
                      <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                        <div className="flex justify-between items-center px-5">
                          {/* Left Logo */}
                          <div className="flex flex-col justify-center items-center text-center">
                            <img
                              src={require('src/assets/Choqorak/logo1.png')}
                              width="100"
                              height="100"
                              alt="logo1"
                            />
                          </div>

                          {/* Center Text */}
                          <div className="text-base text-center font-bold print:text-base">
                            <h3>چقرک مرکز پخش مواد خوراکی</h3>
                            <h3>گزارش عمومی عواید</h3>
                            {startDate && endDate && startDate.getTime() !== endDate.getTime() ? (
                              <h3>
                                {startDate && endDate
                                  ? `گزارش عواید از ${startDate.toLocaleDateString('fa-AF')} الی ${endDate.toLocaleDateString('fa-AF')}`
                                  : 'تاریخ مشخص نشده است'}
                              </h3>
                            ) : (
                              <h3>
                                {startDate && endDate
                                  ? `گزارش عواید از ${startDate.toLocaleDateString('fa-AF')} `
                                  : 'تاریخ مشخص نشده است'}
                              </h3>
                            )}
                          </div>

                          {/* Right Logo */}
                          <div className="flex flex-col justify-center items-center text-center">
                            <img
                              src={require('src/assets/Choqorak/logo2.png')}
                              width="200"
                              height="400"
                              alt="logo2"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Summary Section */}
                      <div>
                        <h3 className="text-center text-xl font-bold border-4 border-black p-2">
                          {translate('Shop.Report.ReportSummary')}
                        </h3>
                        <table className="w-full border border-black text-left text-sm">
                          <thead>
                            <tr className="bg-gray-200">
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('Income.Currency')}
                              </th>
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('IncomeCategory.IncomeCategory')}
                              </th>
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('Income.Amount')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(groupedReport).map(([currencyName, categories], index) => {
                              const categoryEntries = Object.entries(categories);
                              return categoryEntries.map(([categoryName, amount], subIndex) => (
                                <tr key={`${index}-${subIndex}`}>
                                  {/* Only render currency cell once, with rowSpan */}
                                  {subIndex === 0 && (
                                    <td
                                      className="px-4 py-2 border border-black text-center align-middle"
                                      rowSpan={categoryEntries.length}
                                    >
                                      {currencyName}
                                    </td>
                                  )}
                                  <td className="px-4 py-2 border border-black text-center">{categoryName}</td>
                                  <td className="px-4 py-2 border border-black text-center">
                                    {amount}{' '}
                                    {currencyName === 'Afghani' ? GetCurrencySymbol('afn') : GetCurrencySymbol('dollar')}
                                  </td>
                                </tr>
                              ));
                            })}

                            {Object.entries(grandTotalsByCurrency).map(([currency, total], index) => (
                              <tr key={`grand-${index}`}>
                                <td colSpan={2} className="px-4 py-2 border border-black text-center font-bold">
                                  مجموع کل ({currency})
                                </td>
                                <td className="px-4 py-2 border border-black text-center font-bold">
                                  {total}{' '}
                                  {currency === 'Afghani' ? GetCurrencySymbol('afn') : GetCurrencySymbol('dollar')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Footer Section */}
                      {/* Add footer if needed */}
                    </div>
                  </div>
                )}

              </div>
            ))}
          </>
        ) : (
          <div className="flex justify-center items-center">
            {translate('ReceptionDashboard.NoRecordFound')}
          </div>
        )}
      </div>
    </>
  );
}
